import React, { useContext, useState } from "react";
import AppContext from "../../AppContext";
import ChatWindow from "../../components/ChatWindow";
import { useNavigate } from "react-router-dom";

const ChatPage = () => {
  const { user } = useContext(AppContext);
  const navigate = useNavigate();

  return <ChatWindow userId={user._id} mini={false} />;
};

ChatPage.propTypes = {};

export default ChatPage;
